import * as config from 'config'

export const RELEASED_WIDGET = `<released-widget channel-id="${config.getRequired('release-notes-widget-channel-id')}"></released-widget>`
export const RELEASED_PAGE = `<released-page channel-id="${config.getRequired('release-notes-page-channel-id')}"></released-page>`
export const RELEASED_BADGE = `<released-badge channel-id="${config.getRequired('release-notes-page-channel-id')}"></released-badge>`
